import React, { useEffect, useState } from 'react';
import TableComponent from "../../components/Table";
import { useFetchGameQuery, useDeleteGameMutation, useUpdateGameStatusMutation } from '../../features/api/gameApi';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const headers = [
  { title: "#", key: "id", type: "id" },
  { title: "TITLE", key: "title", type: "text" },
  { title: "IMAGE", key: "image", type: "image" },
  { title: "DESCRIPTION", key: "description", type: "text" },
];

function Games() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, perPage: 10 });
  const { data, refetch } = useFetchGameQuery(params);
  const userData = useSelector(state => state?.auth?.user);

  useEffect(() => {
    refetch();
  }, [refetch, params]);

  useEffect(() => {
    if (!userData?.roleData['games_viewAll']) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.roleData]);

  const [deleteYoutube] = useDeleteGameMutation();
  const [updateGameStatus] = useUpdateGameStatusMutation();

  const handleEdit = (id) => {
    navigate(`/games/edit/${id}`);
  }
  const handleDelete = async (id) => {
    const response = await deleteYoutube(id);
    refetch();
    if (response?.data?.status) {
      toast.success(response?.data?.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
    }
  }

  const handleStatusChange = async (id, status) => {
    const response = await updateGameStatus({
      _id: id,
      status: status
    });
    refetch();
    if (response?.data?.status) {
      toast.success(response?.data?.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
    }
  }

  const onSearch = (value) => {
    setParams({ ...params, search: value, page: 1 })
  }

  const onPaginationCountChange = (value) => {
    setParams({ ...params, perPage: value })
  }

  const onPaginationChange = (value) => {
    setParams({ ...params, page: value })
  }

  return (
    <div className="container">
      <div className="table-listing">
        <TableComponent
          title="Games"
          defaultTitle={true}
          headers={headers}
          data={data?.data?.list}
          metaData={data?.data?.meta}
          rows={10}
          buttonContent="Add Game"
          view={false}
          add={false}
          buttonStatus={true}
          actions={[{ type: 'edit', role: 'edit', onClick: handleEdit }, { type: 'delete', role: 'delete', onClick: handleDelete }, { type: 'playPause', role: 'edit', onClick: handleStatusChange }]}
          permissionPath="games"
          currentPage={params?.page}
          onPaginationChange={onPaginationChange}
          onSearch={onSearch}
          onPaginationCountChange={onPaginationCountChange}
        />
      </div>
      <ToastContainer />
    </div>
  );
}

export default Games;